import React from "react";
import { motion } from "framer-motion";
import {
  FileText,
  TrendingUp,
  Bell,
  KeySquare,
  BookOpen,
  Users,
  HeartHandshake,
  MessageSquare,
  Wifi,
  ChevronRight,
} from "lucide-react";

const Hero = () => {
  const features = [
    { icon: FileText, text: "Online Forms", color: "text-blue-600" },
    { icon: TrendingUp, text: "Results", color: "text-green-600" },
    { icon: Bell, text: "Admit Card", color: "text-yellow-600" },
    { icon: KeySquare, text: "Answer Key", color: "text-purple-600" },
    { icon: BookOpen, text: "Syllabus", color: "text-pink-600" },
    { icon: Users, text: "Career News", color: "text-cyan-600" },
    { icon: HeartHandshake, text: "Sarkari Yojana", color: "text-red-600" },
    { icon: MessageSquare, text: "Scholarship", color: "text-indigo-600" },
  ];

  const announcements = [
    { title: "RRB Group D Exam City / Admit Card", posts: "" },
    { title: "UP Home Guard Form", posts: "(41,424 Posts)" },
    { title: "RRS Junior Engineer Form", posts: "(2569 Posts)" },
    { title: "US Anganwadi Bharti 2025", posts: "(53,289 Post)" },
    { title: "KVS NVS Online Form", posts: "(14,967 Posts)" },
    { title: "BSSC Inter Level Form", posts: "(23175 Posts)" },
    { title: "UP Scholarship Online Form 2025-26", posts: "" },
  ];

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-8">
      <div className="mx-auto max-w-6xl">
        {/* Header */}
        <div className="mb-10 text-center">
          <h1 className="mb-3 text-4xl font-bold text-gray-800">
            Sarkari Result <span className="text-blue-600">Setu</span>
          </h1>
          <p className="mb-6 text-gray-600">
            Get Online Form, Results, Admit Card, Answer Key, Syllabus, Career
            News, Sarkari Yojana, Scholarship, Sarkari Notice etc.
          </p>

          <div className="mb-8 flex flex-wrap justify-center gap-4">
            <div className="flex items-center gap-2 rounded-full bg-red-100 px-4 py-2 text-red-700">
              <Wifi className="h-4 w-4" />
              <span className="font-semibold">LIVE</span>
            </div>

            <button className="flex items-center gap-2 rounded-lg bg-green-600 px-5 py-2 text-white hover:bg-green-700">
              <MessageSquare className="h-5 w-5" />
              <span>Join WhatsApp</span>
              <ChevronRight className="h-4 w-4" />
            </button>
          </div>
        </div>

        {/* Features */}
        <div className="mb-12">
          <h2 className="mb-6 text-center text-2xl font-bold text-gray-800">
            SarkariResult Tools
          </h2>
          <div className="grid grid-cols-2 gap-4 md:grid-cols-4 lg:grid-cols-5">
            {features.map((feature, index) => (
              <div
                key={index}
                className="rounded-lg bg-white p-4 text-center shadow-md hover:shadow-lg"
              >
                <div className={`${feature.color} mb-2 flex justify-center`}>
                  <feature.icon className="h-8 w-8" />
                </div>
                <p className="text-sm font-medium text-gray-700">
                  {feature.text}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Announcements */}
        <div>
          <h2 className="mb-6 text-center text-2xl font-bold text-gray-800">
            Latest Updates
          </h2>
          <div className="space-y-4">
            {announcements.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                className="rounded-lg border-l-4 border-blue-500 bg-white p-4 shadow-md hover:shadow-lg"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="font-semibold text-gray-800">
                      {item.title}
                    </h3>
                    {item.posts && (
                      <p className="mt-1 text-sm text-gray-600">{item.posts}</p>
                    )}
                  </div>
                  <button className="font-medium text-blue-600 hover:text-blue-800">
                    View Details →
                  </button>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
